module.exports = __webpack_public_path__ + "static/media/bg.a2e0213a.png";